import MissingPage from "./MissingPage";

export default MissingPage;
